module.exports = __webpack_public_path__ + "static/media/get_your_results.a5d8a4d4.svg";